import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";

import "./signUpBody.scss";
import Button from "components/Button/index";
import { signupContext } from "context/SignupContext";
import useTheme from "hooks/observer";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
};

const SignUpBody = ({ nextStep, prevStep, setCanGoNext }) => {
  const isMobile = useIsMobile();
  const theme = useTheme();
  const { formData, setFormData, isTypeSelect, setIsTypeSelect } =
    useContext(signupContext);
  const [errors, setErrors] = useState({});
  const [consentChecked, setConsentChecked] = useState(false);
  const [showConsentError, setShowConsentError] = useState(false);

  const [isFormValid, setIsFormValid] = useState(false);

  // const navigate = useNavigate();

  // const validate = (name, value, type) => {
  //   let error = "";
  //   if (name === "name") {
  //     if (type === "individual") {
  //       const nameRegex = /^[a-zA-Z ]{2,30}$/;
  //       if (!value) {
  //         error = "Name is required";
  //       } else if (!nameRegex.test(value)) {
  //         error =
  //           "Name must be 2-30 characters and contain only letters and spaces";
  //       }
  //     } else if (type === "org") {
  //       const orgNameRegex = /^[a-zA-Z0-9 ]{2,50}$/;
  //       if (!value) {
  //         error = "Organisation name is required";
  //       } else if (!orgNameRegex.test(value)) {
  //         error =
  //           "Must be 2-50 characters and contain only letters, numbers, and spaces";
  //       }
  //     }
  //   }

  //   if (name === "email") {
  //     if (!value) {
  //       error =
  //         type === "individual"
  //           ? "Email is required"
  //           : "Organisation email is required";
  //     } else {
  //       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //       if (!emailRegex.test(value)) {
  //         error = "Please enter the valid email id";
  //       }
  //     }
  //   }

  //   return error;
  // };

  // test
  const validate = (name, value, type) => {
    let error = "";

    if (name === "name" && type !== "individual") {
      const orgNameRegex = /^[a-zA-Z ]{2,256}$/;
      if (!value.trim()) {
        error = "Organisation name is required";
      } else if (!orgNameRegex.test(value.trim())) {
        error =
          "Must be 2-256 characters (letters and spaces only)";
      }
    }

    if (name === "email") {
      if (!value) {
        error =
          type === "individual"
            ? "Email is required"
            : "Organisation email is required";
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(value)) {
          error = "Please enter a valid email ID";
        }
      }
    }

    return error;
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "name" && isTypeSelect === "org") {
      // Allow only letters and spaces
      value = value.replace(/[^a-zA-Z ]/g, "");
    }

    const error = validate(name, value, isTypeSelect);
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: error });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nameError = validate("name", formData.name, isTypeSelect);
    const emailError = validate("email", formData.email, isTypeSelect);


    if (!nameError && !emailError && consentChecked) {
      //  setFormData({ name: "", email: "" });
      // navigate("/password");
      nextStep();
    } else {
      setErrors({ name: nameError, email: emailError });
    }
  };

  const handleKeyDown = (e) => {

    if (e.key === "Enter") {
      // Only allow Enter key submission if consent is checked
      if (consentChecked) {
        setShowConsentError(false);
        handleSubmit(e);
      } else {
        e.preventDefault();
        // Show red border on consent section when Enter is pressed without consent
        setShowConsentError(true);
      }
    }

    if (isTypeSelect === "org" && e.target.name === "name") {
      // Allow letters, space, and control keys
      const isLetterOrSpace = /^[A-Za-z ]$/.test(e.key);
      const isControlKey = [
        "Backspace",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "Delete",
        "Home",
        "End"
      ].includes(e.key);

      if (!isLetterOrSpace && !isControlKey && !e.ctrlKey && !e.metaKey) {
        e.preventDefault();
      }
    }

  };

  // const checkFormValidity = () => {
  //   return (
  //     Object.values(errors).every((error) => !error) &&
  //     Object.values(formData).every((value) => value.trim() !== "")
  //   );
  // };

  // test
  const checkFormValidity = () => {
    const hasConsent = consentChecked;

    if (isTypeSelect === "individual") {
      return !errors.email && formData.email.trim() !== "" && hasConsent;
    }

    return (
      Object.values(errors).every((error) => !error) &&
      Object.values(formData).every((value) => value.trim() !== "") &&
      hasConsent
    );
  };

  useEffect(() => {
    const isValid = checkFormValidity();
    setIsFormValid(isValid);
    if (setCanGoNext) setCanGoNext(isValid);
  }, [formData, errors, consentChecked, setCanGoNext]);

  useEffect(() => {
    // We only reset consent and error states on mount, but preserve name/email in formData for persistence
    setConsentChecked(false);
    setShowConsentError(false);
  }, []);


  // if (isMobile) {
  //   return (
  //     <section className="signIn">
  //       <div className="container signInContainer">
  //         <div className="titleSection">
  //           <h1 className="title">Sign Up</h1>
  //         </div>
  //         <div className="contentSection">
  //           <div className="signInData">
  //             <div className="signInDataContents">
  //               <p style={{ textAlign: "center", color: "#888", fontSize: "1.2rem" }}>
  //                   <b>Thank you for choosing Ysafe.io.</b> <br />
  //                   Our platform is currently optimized for desktop and laptop devices.<br />
  //                   Please access it from a computer for the best experience.<br />
  //                   <b>Mobile applications will be available soon!</b>
  //               </p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </section>
  //   );
  // }

  const handleBack = () => {
    if (prevStep) {
      prevStep();
    }
  };

  return (
    <>
      <section className="signUpBody">
        <div className="container signUpBodyContainer">
          <div className="signUpHeader">
            <button
              type="button"
              onClick={handleBack}
              className="signUpBackButton"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M15 18L9 12L15 6"
                  stroke={theme === "dark" ? "white" : "black"}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="titleSection">
              <h1 className="title">Welcome to Induz</h1>
              {/* <p className="content">
                Sign up with the secure storage provider for secure and reliable
                data management.
              </p> */}
            </div>
          </div>
          <div className="contentSection">
            <div className="signUpData">
              <div className="signUpDataContents">
                <form className="form" onSubmit={handleSubmit} >
                  <div className="formData">
                    {isTypeSelect === "individual" && (
                      <>
                        {/* <div className="field">
                          <label htmlFor="name">Name</label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Your Name"
                            onChange={handleChange}
                            maxLength={30}
                            value={formData.name}
                            className={errors.name ? "errorBorder" : ""}
                          />
                          {errors.name && (
                            <p className="errorMsg">{errors.name}</p>
                          )}
                        </div> */}
                        <div className="field">
                          <label htmlFor="email">Email</label>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="you@company.com"
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            value={formData.email}
                            className={errors.email ? "errorBorder" : ""}
                          />
                          {errors.email && (
                            <p className="errorMsg">{errors.email}</p>
                          )}
                        </div>
                      </>
                    )}
                    {isTypeSelect === "org" && (
                      <>
                        <div className="field">
                          <label htmlFor="name">Organisation Name</label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Eg : Induz"
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            maxLength={256}

                            value={formData.name}
                            className={errors.name ? "errorBorder" : ""}
                          />
                          {errors.name && (
                            <p className="errorMsg">{errors.name}</p>
                          )}
                        </div>
                        <div className="field">
                          <label htmlFor="email">Organisation Email</label>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="you@company.com"
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            value={formData.email}
                            className={errors.email ? "errorBorder" : ""}
                          />
                          {errors.email && (
                            <p className="errorMsg">{errors.email}</p>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className={`consentCheckboxContainer ${showConsentError ? "consentError" : ""}`}>
                    <input
                      type="checkbox"
                      id="consentCheckbox"
                      checked={consentChecked}
                      onChange={(e) => {
                        setConsentChecked(e.target.checked);
                        if (e.target.checked) {
                          setShowConsentError(false);
                        }
                      }}
                      className="consentCheckbox"
                    />
                    <label htmlFor="consentCheckbox" className="consentLabel">
                      I agree to the{" "}
                      <a
                        href="https://induz.io/privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="consentLink"
                      >
                        privacy policy
                      </a>
                      {" "}and{" "}
                      <a
                        href="https://induz.io/terms-of-service/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="consentLink"
                      >
                        terms of service
                      </a>
                      .
                    </label>
                  </div>
                  <div className="startButtonContainer">
                    {/* <button
                      type="submit"
                      className={`startButton ${isFormValid ? "enabled" : "disabled"}`}
                      disabled={!isFormValid}
                    >
                      Get Started
                    </button> */}
                    <Button
                      type="violet"
                      disabled={!isFormValid}
                      title="Get Started"
                      btnType="submit"
                    />
                  </div>
                </form>
              </div>
              <div className="loginField">
                <p className="loginContent">
                  Already have an account?{" "}
                  <span className="colorText" onClick={() => {
                    setFormData((prev) => {
                      return {
                        ...prev,
                        individualEmail: "",
                        individualPassword: "",
                        orgName: "",
                        orgEmail: "",
                        orgPassword: ""
                      };
                    });
                  }}>
                    <Link
                      to="/signin"
                      style={{
                        color: "var(--text-highlight",
                        textDecoration: "none"
                      }}
                    >
                      Sign In
                    </Link>
                    {/* <Link to="/sign-in" >Sign In</Link> */}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignUpBody;
